import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import SchoolIcon from "@mui/icons-material/School";
import WorkIcon from "@mui/icons-material/Work";

function Experience() {
  return (
    <div className="experience">
      <VerticalTimeline lineColor="#3e497a">
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="Sept 2025 - Present"
          iconStyle={{ background: "#e9d35b", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            RouteSmart Technologies Inc. - A FedEx Company.
          </h3>

          <h4 className="vertical-timeline-element-subtitle"> Operations Research Analyst - Columbia MD.</h4>

          <p> - Design and implement high-performance routing solvers in C++.
              - Propose and test new algorithmic solutions to complex logistics problems (TSP, Postman Problem, etc.)
              - Optimize performance and quality of existing solvers under client specific constraints.
              - Collaborate with cross functional teams to integrate features and enhancements
              - Debug recursive logic, implement turn penalties, fleet constraints, and zone based routing.
              - Support edge cases like left hand driving , container return logistics and user reported route adjustments.
              - Contribute to solver evolution aligned with real world client needs.
              - Designed and implemented a custom rule-based prioritization system in a routing engine, ensuring correct order enforcement and accurate real-time cost evaluation within a recursive optimization algorithm</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="June 2024 - May 2025"
          iconStyle={{ background: "#e9d35b", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Software Developer Intern - Quantum Computing Inc.
          </h3>
          <h4 className="vertical-timeline-element-subtitle">Hoboken, NJ</h4>
          <p>
            -Designed C++ + Python algorithms optimizing dataflows; boosted solver efficiency by 19% in routing simulations. 
            − Applied network analysis to model ERP
            –CRM flows; improved enterprise operations decisions with 21% faster outputs. 
            − Built anomaly detection solvers in SQL + C++; reduced error rate by 23%, improving solver accuracy for production. 
            − Developed statistical optimization models; improved KPI forecasting reliability by 20% across routing workflows.
            − Enhanced ETL pipelines in Python/C++; improved data throughput 16% to support large-scale solver computations. 
            − Partnered with engineers on Fabric + Databricks; integrated algorithms for scalable high-performance routing. 
            − Deliver BI adoption training for business teams; increased data literacy and Power BI usage across stakeholders.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2023 - 2025"
          iconStyle={{ background: "#3e497a", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Stevens Institute of Technology
          </h3>

          <h4 className="vertical-timeline-element-subtitle">Masters Degree</h4>

          <p> Computer Science</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2021 - 2023"
          iconStyle={{ background: "#e9d35b", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Application Development Analyst - Accenture
          </h3>
          <h4 className="vertical-timeline-element-subtitle">Pune, MH</h4>
          <p>-Automated optimization QA in Python + C++; cut validation cycles by 28%, improving solver performance testing.
             − Applied operations research on SQL + BI datasets; identified anomalies reducing outage investigations by 21%. 
             − Built predictive algorithms for financial KPIs; improved forecast accuracy by 17% across client operational models.
             − Conducted anomaly detection in SQL datasets; uncovered recurring errors, improving reporting data integrity by 15%. 
             − Designed scalable pipelines with CI/CD; boosted solver deployment stability and reduced rework by 22%.
             − Documented algorithm design + data models; cut onboarding ramp-up time by 26% for new solver engineering hires. 
             − Conducted benchmarking of network KPIs; provided insights improving business routing practices enterprise wide. 
             − Designed reports with trend benchmarks; provided actionable recommendations for improving client business practices.</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2016 - 2020"
          iconStyle={{ background: "#3e497a", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Sinhagad Institute of Technology Science
          </h3>

          <h4 className="vertical-timeline-element-subtitle">
            Bachelor's Degree
          </h4>

          <p> Mechanical Engineering</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2014 - 2016"
          iconStyle={{ background: "#3e497a", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Karmaveer Bhaurav Patil VidyaMandir and Jr. College
          </h3>
          <p> Junior College/High School</p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
}

export default Experience;
